import React, {PropTypes} from 'react';
import StandardModal from 'shared/StandardModal.jsx';

const ConfirmStatusChangeModal = ({
  newStatus,
  currentStatus,
  visible,
  onCancelClick,
  onConfirmClick
}) => (
  <StandardModal
    visible={visible}
    title={`Tournament - ${currentStatus}`}
    onCloseClick={onCancelClick}
  >
    <div className="text-center">
      <div>
        <p>
          You are about to change the Tournament Status to <strong>{newStatus}</strong>.
        </p>
        <p>
          This change cannot be undone.
        </p>
      </div>
    </div>
    <hr />
    <div className="text-right">
      <button
        type="button"
        className="btn btn-link"
        onClick={onCancelClick}
      >{`Cancel`}</button>
      {` `}
      <button
        type="button"
        className="btn btn-primary btn-lg"
        onClick={() => onConfirmClick(newStatus)}
      >{'Yes. Change Tournament Status.'}</button>
    </div>
  </StandardModal>
);

ConfirmStatusChangeModal.propTypes = {
  newStatus: PropTypes.string,
  currentStatus: PropTypes.string,
  visible: PropTypes.bool,
  onCancelClick: PropTypes.func,
  onConfirmClick: PropTypes.func
};

ConfirmStatusChangeModal.defaultProps = {
  newStatus: '',
  currentStatus: '',
  visible: false
};

export default ConfirmStatusChangeModal;



// WEBPACK FOOTER //
// ./src/features/tournament/status/ConfirmStatusChangeModal.jsx